import React, { useEffect, useRef, useState } from "react";
import Utils from "../../../helpers/Utils";
import DynamicSkeleton from "./DynamicSkeleton";
import GlobalEmptyPage from "../../Common/GlobalEmptyPage";
import { currentPackageHistoryList } from "../../../api/billingApi";
import { useIsMounted } from "../../../hooks/IsMounted";

const CurrentUsageHistory = ({ query, onShowDetails }) => {
  const isMounted = useIsMounted();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [scrolling, setScrolling] = useState(false);
  const [page, setPage] = useState(1);
  const perPage = 20;
  const [hasMore, setHasMore] = useState(true);
  const scrollingDiv = useRef(null);
  const sortType = "desc";
  const sortBy = "id";
  const [debouncedQuery, setDebouncedQuery] = useState(null);

      useEffect(() => {
        loadData(page);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [perPage, sortType]);

        useEffect(() => {
            if(debouncedQuery !== null){
                setData([]);
                loadData(1,true);
                
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [debouncedQuery]);
    
        useEffect(() => {
            if (isMounted) {
                const timer = setTimeout(() => {
                    setDebouncedQuery(query);

                }, 1000);
    
                return () => clearTimeout(timer);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [query]);

const loadData = async (nextPage, _clearPrev = false) => {
  setLoading(true);
  try {
    const response = await currentPackageHistoryList({
      form_data: {
        page: nextPage,
        per_page: perPage,
        sort_by: sortBy,
        sort_type: sortType,
        query: debouncedQuery,
      },
    });
    if(response.data.status === 'success'){
          let tempData = _clearPrev ? [] : [...data];

    response.data.data.data.forEach((element) => {
      tempData.push(element);
    });

    setData(tempData);
    setPage(nextPage);

    if (response.data.data.next_page_url) {
      setHasMore(true);
      setPage(nextPage);
    } else {
      setHasMore(false);
    }
    } else {
        window.showNotification("ERROR", response.data.message);
    }
    
  } catch (error) {
    console.error('Error loading data:', error);
  } finally {
    setLoading(false);
    setScrolling(false);
  }
};

    const loadMore = (e) => {
  const target = e.target;
  const threshold = 20; 

  const isBottomReached =
    target.scrollTop + target.clientHeight >= target.scrollHeight - threshold;

  if (isBottomReached && hasMore && !scrolling && !loading) {
    setScrolling(true);
    const nextPage = page + 1;
    loadData(nextPage);
  }
};

  const renderData = () => {
    if (loading && !data.length) {
      return (
        <tr>
          <td colSpan="5">
            <div>
              <DynamicSkeleton count={6} />
            </div>
          </td>
        </tr>
      );
    } else if (!loading && !data.length) {
      return (
        <tr>
          <td
            colSpan="5"
            style={{ height: "300px", padding: 0 }}
            className="text-center align-middle"
          >
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <GlobalEmptyPage
                emptyPageMessage="NO DATA AVAILABLE."
                maxHeight="440px"
              />
            </div>
          </td>
        </tr>
      );
    } else if (Array.isArray(data) && data.length) {
      return (
        <>
          {data.map((item, index) => {
            let typeFor = "";
            if (item.conversion_type == 2 && item.type_for == 1) {
              typeFor = "SMS Notification";
            } else if (item.conversion_type == 2 && item.type_for == 4) {
              typeFor = "Email Notification";
            } else {
              typeFor = Utils.getTextForType(item.type_for);
            }

            let type = item.type == 1 ? "CREDIT" : "DEBIT";

            let details = false;
            let myJson = null;
            if (item.contact_info && item.contact_info !== "") {
              try {
                if (
                  item.contactInfo !== undefined &&
                  item.contactInfo !== null
                ) {
                  myJson = JSON.parse(
                    item.contact_info.replace(/&quot;/g, '"')
                  );
                }
              } catch (e) {
                console.log(e);
              }
            }

            if (
              item.type == 1 ||
              (myJson && myJson.has_conversion !== null) ||
              item.type_for != 113 ||
              item.type_for != 112
            ) {
              details = true;
            }

            let usageDate = window.globalTimezoneConversionToDifferentTimezone(
              item.created_at
            );

            return (
              <tr key={index}>
                <td className="pl-5">
                  <p className="text-dark-blue-65 subtitle-1 d-flex justify-content-start align-items-center">
                    {typeFor ? typeFor : ""}
                  </p>
                </td>
                <td>
                  <p className="heading-6 text-light-gray-2">
                    $
                    {item.credit_amount.endsWith(".0000")
                      ? `${item.credit_amount.slice(0, -4)}00`
                      : item.credit_amount}
                  </p>
                </td>
                <td>
                  <p className="subtitle-1 text-light-gray-2">{usageDate}</p>
                </td>
                <td>
                  <span
                    className={`${
                      type === "CREDIT"
                        ? "bg-light-green black-text"
                        : "bg-red white-text"
                    } subtitle-1 radius-5 text-center py-2 px-3`}
                  >
                    {type}
                  </span>
                </td>
                <td>
                  {details && (
                    <a
                      href="!#"
                      className="bg-light-blue subtitle-1 radius-5 white-text text-center accent--bg--color"
                      onClick={(e) => {
                        e.preventDefault();
                        onShowDetails(item);
                      }}
                    >
                      Details
                    </a>
                  )}
                </td>
              </tr>
            );
          })}

          {scrolling && (
            <>
              <tr>
                <td colSpan="5">
                  <DynamicSkeleton count={2} />
                </td>
              </tr>
            </>
          )}
        </>
      );
    }
  };

  return (
    <div>
      <div
        class={"scrollable_table__open scrollable_table"}
        onScroll={(e) => loadMore(e)} ref={scrollingDiv}
       >
        <table class="usage_history_table">
          <thead>
            <tr>
              <td class="pl-5">
                <p class="text-dark-blue heading-6">Type</p>
              </td>
              <td>
                <p class="text-dark-blue heading-6">Cost ($)</p>
              </td>
              <td>
                <p class="text-dark-blue heading-6">Date</p>
              </td>
              <td>
                <div class="d-flex justify-content-center">
                  <p class="text-dark-blue heading-6">Transaction Type</p>
                </div>
              </td>
              <td>
                <p class="text-dark-blue heading-6">Details</p>
              </td>
            </tr>
          </thead>
          <tbody>{renderData()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default CurrentUsageHistory;
